import type { ApiPipeline, ApiPipelineArgument } from "avvir";
import type { AvvirEvent } from "type_aliases";

export type TriggeredPipeline = ApiPipeline & { retryArguments?: ApiPipelineArgument };

export type PipelineRunningProcessTriggeredEvent = AvvirEvent<typeof PIPELINE_RUNNING_PROCESS_TRIGGERED, TriggeredPipeline>

const pipelineRunningProcessTriggered = (pipeline: TriggeredPipeline): PipelineRunningProcessTriggeredEvent => ({
  type: PIPELINE_RUNNING_PROCESS_TRIGGERED,
  payload: pipeline
});

export const PIPELINE_RUNNING_PROCESS_TRIGGERED = "pipeline_running_process_triggered";

export default pipelineRunningProcessTriggered;
